<script lang="typescript">
    import OptionSelector from "./OptionSelector.svelte";
    import { push, pop } from "svelte-spa-router";
    import { state, setState } from "../stores.js";
    import { MessageType } from "../types";
    import type { VariantImage } from "../types";
    import type { LogoImage } from "../types";
    import { chevron, chevronBack } from "../appData.js";
    import {
        computeTotalPrice,
        getAvailableSecondaryVariants,
        getCurrency,
        getBaseLensObject,
    } from "../utils";
    import { getPrimaryVariant } from "../utils";
    import { onDestroy } from "svelte";
    export let title: string;
    export let images: VariantImage;
    export let logo: LogoImage;

    if ($state.rxId === null) {
        window.location.replace("/");
    } else if ($state.primaryVariantIndex === null) {
        // User used "back to options" button, then browser "back" button.
        window.location.replace("/");
    }

    const primaryVariant = getPrimaryVariant($state);
    const availableSecondaryVariants = getAvailableSecondaryVariants(
        $state.focalType,
        $state.baseLensKey,
        $state.primaryVariantIndex
    );
    const backButtonHandler = () => {
        setState({ message: MessageType.RESET_SECONDARY_VARIANT });
        pop();
    };

    const totalPrice = computeTotalPrice(
        getBaseLensObject($state.focalType),
        $state.baseLensKey,
        primaryVariant,
        null,
        $state.region
    );

    onDestroy(() => window.scrollTo(0, 0));
</script>

<section>
    <div class="page-container pt-8 px-8">
        <nav class="w-full">
            <button
                class="btn-secondary mr-auto text-base px-4"
                on:click|preventDefault={() => backButtonHandler()}
            >
                {@html chevronBack}Back to options
            </button>
        </nav>

        <div class="p-8 m-8 bg-background w-full">
            <div class="mb-8 w-full border-b-2 pb-1.5 flex justify-between items-end">
                {#if title}
                    <h1>{title}</h1>
                {/if}
                {#if logo}
                    <img src={logo.src} alt={logo.alt_text} class="w-1/4" />
                {/if}

                <div>
                    <span class="inline text-2xl font-bold">{getCurrency($state)}</span>
                    <h1 class="inline">
                        {totalPrice}
                    </h1>
                </div>
            </div>
            <div class="flex flex-row h-auto items-start space-x-8 block">
                <div
                    class="img-background w-1/3 h-1/3 max-w-sm relative"
                    style={`background-image: url(${images.after})`}
                >
                    <img
                        class="w-full h-full object-cover rounded-full hide-on-hover"
                        src={images.before}
                        alt="spectacle lens"
                    />
                </div>
                <div class="w-2/3 ml-16">
                    <slot />
                    <OptionSelector {primaryVariant} {availableSecondaryVariants} />
                </div>
            </div>
            <nav class="flex w-full justify-end mt-8 items-center">
                <button type="button" class="btn-primary" on:click={() => push("/results/")}>
                    Order now{@html chevron}
                </button>
            </nav>
        </div>
    </div>
</section>

<style>
    /* :global directive applies styles here to components passed in to <slot></slot>. */
    div :global(ul) {
        @apply mb-4;
    }

    div :global(h2) {
        @apply mb-2;
    }

    div :global(h3) {
        @apply mb-2;
    }

    div :global(li) {
        @apply mb-2;
    }

    div :global(p) {
        @apply mb-4;
    }
</style>
